module.exports = __webpack_public_path__ + "img/method-photo.7bfa926c.png";